import styled from "styled-components";
import { createContext, useState, useEffect, useContext } from "react";
import { listenToHotTopicsDatabase } from "../Firebase";
import { CurrentUserContext } from "./CurrentUserContext";

export const HotTopicsContext = createContext<HotTopic[]>([]);

export default function HotTopicsContextProvider(props: Props) {
  const [hotTopics, setHotTopics] = useState<HotTopic[]>([]);
  const currentUserContext = useContext(CurrentUserContext);
  const firebaseUser = currentUserContext?.currentFirebaseUser;

  useEffect(() => {
    const unsubscribeFromHotTopics = listenToHotTopicsDatabase(
      (hotTopics: HotTopic[]) => {
        const orderedHotTopics = hotTopics.sort((a, b) => {
          if (a.label < b.label) {
            return -1;
          }
          if (a.label > b.label) {
            return 1;
          }
          return 0;
        });
        setHotTopics(orderedHotTopics);
      }
    );
    // order all the strings inside of the includes array alphabetically

    return () => {
      unsubscribeFromHotTopics();
    };
  }, [firebaseUser]);

  return (
    <HotTopicsContext.Provider value={hotTopics}>
      {props.children}
    </HotTopicsContext.Provider>
  );
}

interface Props {
  children: React.ReactNode;
}
